export type UserRole = 'admin' | 'account_manager' | 'publisher'

export function getRoleFromId(userRoleId: string): UserRole {
  switch (userRoleId) {
    case '100':
    case '110':
      return 'admin'
    case '101':
    case '102':
    case '103':
    case '104':
    case '105':
    case '106':
    case '107':
    case '108':
      return 'account_manager'
    case '200':
    case '201':
    case '202':
    case '203':
    case '204':
    case '205':
    case '207':
    case '500':
      return 'publisher'
    default:
      return undefined
  }
}
